import { Flex } from 'components';

export const OtherEventsPage = (): JSX.Element => {
  return (
    <Flex align justify width="100%">
      <img src="https://cdn.masochist.me/files/soontm.jpg" alt="Coming soon" />
    </Flex>
  );
};
